import BasicInfo from './basic-info'
import Guarantee from './guarantee'
import Breadcrumb from './breadcrumb'
import Collections from './collections'
import Reviews from './reviews'
import Services from './services'
import Schedule from './schedule'
import FloatPanel from './float-panel'
import Faq from 'components/common/intro/faq'
import { Context, useStore } from 'store/stylist-id'

export default function UserId({ initData }) {
  const store = useStore(initData)

  return (
    <Context.Provider value={ store }>
      <div className='mb-16 md:flex md:container md:justify-between xl:space-x-12'>
        <div className='w-full flex-1'>
          <Breadcrumb />
          <div className='space-y-9 sm:mx-auto'>
            <BasicInfo />
            <Guarantee />
            <Collections />
            <Reviews />
            <Services className='container md:hidden' />
            <Schedule />
          </div>
        </div>
        <div className='relative md:pt-16 min-w-[14rem] md:w-1/3'>
          <FloatPanel />
        </div>
      </div>
      <div className='bg-gray-50'>
        <Faq />
      </div>
    </Context.Provider>
  )
}
